import { render, staticRenderFns } from "./LoansDeclined.vue?vue&type=template&id=07773276&scoped=true&"
import script from "./LoansDeclined.vue?vue&type=script&lang=js&"
export * from "./LoansDeclined.vue?vue&type=script&lang=js&"
import style0 from "./LoansDeclined.vue?vue&type=style&index=0&id=07773276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07773276",
  null
  
)

export default component.exports